import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

import type { BannerSize } from '../../banner'

export const text = css`
  grid-area: subtitle;
  justify-self: start;
  text-align: start;
`

export const textSize: Record<BannerSize, (theme: Theme) => SerializedStyles> = {
  small: (theme) => css`
    font-size: ${theme.typography.app.bodyMobile.fontSize}px;
    line-height: ${theme.typography.app.bodyMobile.lineHeight}px;
    letter-spacing: ${theme.typography.app.bodyMobile.letterSpacing}px;

    ${breakpoint.up('sm')} {
      font-size: ${theme.typography.app.bodySm.fontSize}px;
      line-height: ${theme.typography.app.bodySm.lineHeight}px;
      letter-spacing: ${theme.typography.app.bodySm.letterSpacing}px;
    }
  `,
  medium: (theme) => css`
    font-size: ${theme.typography.app.bodyMobile.fontSize}px;
    line-height: ${theme.typography.app.bodyMobile.lineHeight}px;
    letter-spacing: ${theme.typography.app.bodyMobile.letterSpacing}px;

    ${breakpoint.up('sm')} {
      font-size: ${theme.typography.app.body.fontSize}px;
      line-height: ${theme.typography.app.body.lineHeight}px;
      letter-spacing: ${theme.typography.app.body.letterSpacing}px;
    }
  `,
}
